import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// prettier-ignore
import { openReplyBar, closeReplyBar, openReport, closeReport, openSharePop, openMessageDialog } from '@app-core/app/actions'
// prettier-ignore
import { openCommentPop, closeCommentPop, submitComment } from '@app-core/place/actions'
import { getUserLocation } from '@app-core/currentUser/actions'
import { getTopicList } from '@app-core/posts/actions'
import Place from './components/Place'
import PlaceHead from './components/PlaceHead'
import LayoutContent from '@components/LayoutContent'
import BottomBar, { BottomBarType } from '@components/BottomBar'
import CommentDialog from './components/CommentDialog'
import PopSlidein from '@components/PopSlidein'
import PopOpenHours from './components/PopOpenHours'
import appUrl from '@libs/appUrl'
import PlaceSelectedCommentPopContainer from './PlaceSelectedCommentPopContainer'
// prettier-ignore
import { compose, connect, withRouter, withContext, withTranslation } from '@hocs'
import { PlaceType } from '@app-core/place/reducer'
import { PageContext } from '@libs/pageContext'
import ShowADScript from '@components/ShowADScript'

class PlaceContainer extends PureComponent {
  static defaultProps = {
    isApp: false,
    via: 'direct',
  }

  state = {
    isOpenHoursPopOpen: false,
    openHoursText: [],
    openDay: 0,
  }

  componentDidMount() {
    const { place, t, isApp } = this.props
    if (!place) {
      window.alert(t('你按到什麼了？找不到這頁。'))
    } else {
      this.props.getUserLocation(isApp)
      window.scrollTo(0, 0)
    }
  }

  componentDidUpdate(prevProps) {
    const { placeId } = this.props
    if (prevProps.placeId !== placeId) {
      window.scrollTo(0, 0)
      getTopicList({ postId: placeId })
    }
  }

  _renderBottomBar = () => {
    const { placeType } = this.props
    const place = this.props.place.toJS()
    const { postID, saved = 0, reply = 0 } = place
    return (
      <BottomBar
        postId={postID}
        post={this.props.place}
        savedNum={saved}
        replyNum={reply}
        bottomBarType={placeType === PlaceType.choice ? BottomBarType.Choice : BottomBarType.Ghost}
        openComment={this._bottomBarComment}
        via={'place'}
      />
    )
  }

  submitPlaceComment = (comment) => {
    const { placeId, userId, openCommentPopVia, place } = this.props
    const { clap = 0, text = '' } = comment
    if (clap === 0 && text.trim() === '') {
      this.props.closeCommentPop()
    } else {
      this.props.submitComment({
        userId,
        placeId,
        via: openCommentPopVia,
        place: place.toJS(),
        ...comment,
      })
    }
  }

  _openOpenHoursPop = ({ openHoursText, openDay }) => {
    this.setState({
      isOpenHoursPopOpen: true,
      openHoursText,
      openDay,
    })
  }

  _closeOpenHoursPop = () => {
    this.setState({
      isOpenHoursPopOpen: false,
    })
  }

  _editCurrentUserComment = ({ via }) => {
    const { currentUserCommentId: commentId, openCommentPop, place } = this.props
    openCommentPop({ commentId, via, place: place.toJS() })
  }

  _bottomBarComment = () => {
    this._editCurrentUserComment({ via: 'tabbar.review' })
  }

  _onClickedMore = () => {
    const url = window.location.href
    const post = this.props.place
    this.props.openSharePop({ url, post })
  }

  render() {
    const {
      openReplyBar,
      closeReplyBar,
      replyBarIsOpen,
      report,
      openReport,
      closeReport,
      placeId,
      queryPlaceId,
      place,
      isLoading,
      isCommentPopOpen,
      closeCommentPop,
      isApp,
      placeType,
      giftData,
      hideNavbar,
    } = this.props
    if (!place) return null

    return (
      <LayoutContent
        isApp={isApp}
        report={report.merge({ openReport, closeReport })}
        openReplyBar={openReplyBar}
        closeReplyBar={closeReplyBar}
        replyBarIsOpen={replyBarIsOpen}
        openReport={openReport}
        closeReport={closeReport}
        renderBottomBar={this._renderBottomBar}
      >
        <ShowADScript />
        <PlaceHead place={place} placeType={placeType} queryPlaceId={queryPlaceId} />
        <PageContext.Provider value={{ hideNavbar }}>
          {!isLoading && (
            <Place
              placeId={placeId}
              placeData={place}
              giftData={giftData}
              openOpenHoursPop={this._openOpenHoursPop}
              editCurrentUserComment={this._editCurrentUserComment}
              onClickedMore={this._onClickedMore}
            />
          )}
        </PageContext.Provider>
        <CommentDialog
          isOpen={isCommentPopOpen}
          close={closeCommentPop}
          submit={this.submitPlaceComment}
        />
        <PopSlidein isOpen={this.state.isOpenHoursPopOpen} close={this._closeOpenHoursPop}>
          <PopOpenHours
            openHoursText={this.state.openHoursText}
            openDay={this.state.openDay}
            onClickCloseButton={this._closeOpenHoursPop}
          />
        </PopSlidein>
        <PlaceSelectedCommentPopContainer />
      </LayoutContent>
    )
  }
}

function mapStateToProps(state) {
  const placeId = state.place.get('placeId')
  return {
    userId: state.currentUser.getIn(['userInfo', 'uid']),
    topicList: state.posts.get('topicList'),
    report: state.app.get('report'),
    replyBarIsOpen: state.app.getIn(['replyBar', 'isOpen']),
    placeId,
    placeType: state.place.get('placeType'),
    place: state.place.getIn(['places', placeId]),
    isLoading: state.place.get('isLoading'),
    isCommentPopOpen: state.place.get('isCommentPopOpen'),
    currentUserCommentId: state.place.get('currentUserCommentId'),
    openCommentPopVia: state.place.get('openCommentPopVia'),
    defaultTopic: state.place.get('defaultTopic'),
    hasGift: state.place.get('hasGift'),
    giftId: state.place.get('giftId'),
    giftData: state.place.get('giftData'),
  }
}

export default compose(
  withTranslation(),
  withRouter,
  connect(mapStateToProps, {
    openReplyBar,
    closeReplyBar,
    openReport,
    closeReport,
    openCommentPop,
    closeCommentPop,
    submitComment,
    openSharePop,
    getUserLocation,
    getTopicList,
    openMessageDialog,
  }),
  withContext(
    {
      isApp: PropTypes.bool.isRequired,
      hasGift: PropTypes.bool.isRequired,
      giftId: PropTypes.string,
      placeType: PropTypes.string.isRequired,
      openMessageDialog: PropTypes.func.isRequired,
      breadcrumbLists: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            item: PropTypes.string,
          }),
        ),
      ).isRequired,
    },
    ({ isApp, hasGift, giftId, placeType, openMessageDialog, place, t, i18n }) => ({
      isApp,
      hasGift,
      giftId,
      placeType,
      openMessageDialog,
      breadcrumbLists: [
        [
          {
            name: t('common:publisherName', { locales: t(`common:${i18n.language}`) }),
            item: `${appUrl.appUrl}/explore/featured`,
          },
          {
            name: t('webHeader:map'),
            item: `${appUrl.appUrl}/map`,
          },
          {
            name: place && place.getIn(['place', 'name']),
          },
        ],
      ],
    }),
  ),
)(PlaceContainer)
